import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Col, Input, Label, Row } from 'reactstrap';
import {
  defineMessages,
  FormattedMessage,
  injectIntl,
  intlShape,
} from 'react-intl';

import { modelOf } from '../../../prop-types';
import StorageStore from '../../../store/StorageStore';
import RequestState from '../../../types/RequestState';
import ProductStorageStock from '../ProductStorageStock';
import BlockSpinner from '../../loader/BlockSpinner';
import UnexpectedError from '../../loader/UnexpectedError';
import globalTranslations from '../../../i18n/globalTranslations';
import FullProduct from '../../../models/product/FullProduct';

const MINIMUM_STORAGES_FOR_FILTER = 10;

const messages = defineMessages({
  'stock.filterByStorage': {
    id: 'stock.filterByStorage',
    defaultMessage: 'Filter by storage',
  },
});

@observer
class ProductStoreAvailability extends Component {
  state = {
    selectedStorageId: '',
  };

  getStoreAvailability = () => {
    const { product, activeProductId, storageStore } = this.props;
    let storageList = storageStore.listingStorages;

    if (this.state.selectedStorageId) {
      storageList = [];
      const selectedStorage = storageStore.findStorageById(
        this.state.selectedStorageId
      );
      if (selectedStorage) {
        storageList.push(selectedStorage);
      }
    }

    return storageList.map((storage) => {
      return (
        <ProductStorageStock
          key={storage.id}
          storage={storage}
          stock={product.findStorageStock(activeProductId, storage.id)}
          activeProductId={activeProductId}
          product={product}
        />
      );
    });
  };

  getStorageOptions = () => {
    const { storageStore } = this.props;
    return storageStore.listingStorages.map((storage) => {
      return (
        <option value={storage.id} key={storage.id}>
          {storage.name}
        </option>
      );
    });
  };

  handleChange = (event) => {
    this.setState({ selectedStorageId: event.target.value });
  };

  render() {
    const { product, activeProductId, storageStore } = this.props;
    const stockState = product.stockStates.get(activeProductId);
    const isLoading =
      storageStore.state === RequestState.LOADING ||
      stockState === RequestState.LOADING;
    const isError =
      storageStore.state === RequestState.ERROR ||
      stockState === RequestState.ERROR;
    const showListedRows =
      !!product.stocks.get(activeProductId) &&
      storageStore.state === RequestState.LOADED;

    return (
      <div className="ProductStoreAvailability">
        {isLoading && <BlockSpinner />}
        {isError && <UnexpectedError />}
        {showListedRows && (
          <>
            {storageStore.listingStorages.length >=
              MINIMUM_STORAGES_FOR_FILTER && (
              <>
                <Label for="ProductStoreAvailability__storage-select" hidden>
                  {this.props.intl.formatMessage(
                    messages['stock.filterByStorage']
                  )}
                </Label>
                <Input
                  type="select"
                  name="select"
                  className="ProductStoreAvailability__storage-select"
                  id="ProductStoreAvailability__storage-select"
                  onChange={this.handleChange}
                >
                  <option value="">
                    {this.props.intl.formatMessage(
                      messages['stock.filterByStorage']
                    )}
                  </option>
                  {this.getStorageOptions()}
                </Input>
              </>
            )}
            <div className="ProductStoreAvailability__headings">
              <Row>
                <Col className="ProductStoreAvailability__heading" md="3">
                  <FormattedMessage
                    id="stock.storeHeading"
                    defaultMessage="Store"
                  />
                </Col>
                <Col className="ProductStoreAvailability__heading" md="3">
                  <FormattedMessage {...globalTranslations.availabilityTitle} />
                </Col>
                <Col className="ProductStoreAvailability__heading" md="3">
                  <FormattedMessage
                    id="stock.addressHeading"
                    defaultMessage="Address"
                  />
                </Col>
                <Col className="ProductStoreAvailability__heading" md="3">
                  <FormattedMessage
                    id="stock.contactHeading"
                    defaultMessage="Contact Information and Opening Hours"
                  />
                </Col>
              </Row>
            </div>
            {this.getStoreAvailability()}
          </>
        )}
      </div>
    );
  }
}

ProductStoreAvailability.propTypes = {
  storageStore: modelOf(StorageStore).isRequired,
  product: modelOf(FullProduct).isRequired,
  activeProductId: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
};

export default inject('storageStore')(injectIntl(ProductStoreAvailability));
